let AutoCapitalizeDirective = () => {
    return {
        restrict: 'A',
        require: {
            ngModel: 'ngModel'
        },
        link: function (scope, element, attrs, controller) {

            let capitalized;

            const capitalize = function (inputValue) {
                if (!inputValue) return inputValue = '';
                if (inputValue) capitalized = inputValue.toUpperCase();            

                if (capitalized !== inputValue) {
                    // see where the cursor is before the update so that we can set it back
                    var selection = element[0].selectionStart;
                    controller.ngModel.$setViewValue(capitalized);
                    controller.ngModel.$render();
                    // set back the cursor after rendering
                    element[0].selectionStart = selection;
                    element[0].selectionEnd = selection;
                }
                return capitalized;
            }

            controller.ngModel.$parsers.push(capitalize);
            capitalize(scope[attrs.ngModel]); // capitalize initial value
        }
    }
}

export default AutoCapitalizeDirective;


// WEBPACK FOOTER //
// ./client/app/common/auto-capitalize/capitalize.directive.js